import { useEffect, useRef, useState } from "react";
import { getImagePathBucketPacoca } from "../../global-components/src/utils/utils";
import { api } from "../../services/api";
import { EllipsisVertical, Star, Trash2 } from "lucide-react";
import "./style.css";
import ConfirmationModal from "../Modals/ConfirmationModal";
import { authUser } from "../../global-components/src/utils/auth";
import axios from "axios";
import {
  LIMIT_TEXT_REPORT,
  PACOCA_API_URL,
} from "../../global-components/src/utils/vars";
import { errorMessage } from "../../global-components/src/utils/text";
import { useAuth, useMessage, useTheme } from "../../global-components/src";
import PermissionCheck from "../PermissionCheck";
import ReactPlayer from "react-player";
import { useNavigate } from "react-router-dom";
import StoryInteractions from './story-interactions';
import { getNativeKeyboardHeight, getNativeNavigationHeight, isIOSWebView, isNewApp, isNewAppAndroid } from "../../utils/platform";
import { UserStories } from "../../types";

interface Props {
  usersStories: UserStories[];
  userIndex: number;
  storyIndex: number;
  setUserIndex: (v: number) => void;
  setStoryIndex: (v: number | ((prev: number) => number)) => void;
  onClose: () => void;
  onLoadMore?: () => void;
  onStoryDeleted: (storyId: number, userId: number) => void;
  onStoryViewed?: (storyId: number) => void;
  initiallyShowComments?: boolean;
}

const STORY_TIME = 5000; // 5 segundos

const StoryViewer: React.FC<Props> = ({
  usersStories,
  userIndex,
  storyIndex,
  setUserIndex,
  setStoryIndex,
  onClose,
  onLoadMore,
  onStoryDeleted,
  onStoryViewed,
  initiallyShowComments = false,
}) => {
  const currentUser = usersStories[userIndex];
  const currentStory = currentUser.stories[storyIndex];

  // Start loading the next page before the viewer reaches the last loaded user.
  // The stories bar cannot receive a horizontal scroll event while the viewer is open.
  useEffect(() => {
    if (onLoadMore && userIndex >= usersStories.length - 2) {
      onLoadMore();
    }
  }, [onLoadMore, userIndex, usersStories.length]);
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const { user, token, isSuper } = useAuth();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState(""); // Adicione um estado para a senha
  const [errorModal, setErrorModalPassword] = useState(""); // Adicione um estado para a senha
  const [reasonDeletePost, setReasonDeletePost] = useState(""); // Adicione um estado para a senha
  const { setMessage } = useMessage();
  const [isLimitExceeded, setIsLimitExceeded] = useState(false);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isMuted, setIsMuted] = useState(true);
  const [isHolding, setIsHolding] = useState(false);
  const holdProgressRef = useRef(0);
  const holdTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const isHoldRef = useRef(false);
  const { isDarkMode } = useTheme();
  const [bottomPadding, setBottomPadding] = useState(0);
  const [showBestFriendsInfo, setShowBestFriendsInfo] = useState(false);

  useEffect(() => {
    if (!currentStory || currentStory.id_user === user?.id) return;

    onStoryViewed?.(currentStory.id);
    api(token)?.post?.(`/stories/${currentStory.id}/view`)?.catch(() => {});
  }, [currentStory?.id, currentStory?.id_user, onStoryViewed, token, user?.id]);

  
      
  useEffect(() => {
      const handleKeyboardHeightChange = () => {
          const heightKeyboard = getNativeKeyboardHeight();
          const nativeNavigationHeight = getNativeNavigationHeight() ?? 0;

          setBottomPadding(heightKeyboard ? (heightKeyboard + nativeNavigationHeight) : (nativeNavigationHeight));
      };

      window.addEventListener("keyboardHeightChange", handleKeyboardHeightChange);

      return () => {
          window.removeEventListener("keyboardHeightChange", handleKeyboardHeightChange);
      };
  }, []);

  function ajustaNewApp() {
      if((isNewApp() && isNewAppAndroid()) || isIOSWebView()){
          const nativeNavigationHeight = getNativeNavigationHeight();
          const heightKeyboard = getNativeKeyboardHeight();

          if(nativeNavigationHeight && nativeNavigationHeight > 0){
              setBottomPadding(nativeNavigationHeight + (heightKeyboard ? 0 : 0));
          }

          window.addEventListener("navigationBarHeightChange", ajustaNewApp);
          return () => window.removeEventListener("navigationBarHeightChange", ajustaNewApp);
      }
  }
  useEffect(() => {
      ajustaNewApp()
  }, []);

  useEffect(() => {
      const onResize = () => {
          const visualViewport = window.visualViewport;
          const heightKeyboard = getNativeKeyboardHeight();
          

          if(!heightKeyboard) {
              ajustaNewApp();
          };

          if (!visualViewport) return;

          const offsetTop = visualViewport.offsetTop;
          const offsetBottom = window.innerHeight - visualViewport.height - offsetTop;

          if(heightKeyboard){
              setBottomPadding(prev => (prev !== offsetBottom ? (offsetBottom > 0 ? offsetBottom : 0) : prev));
          }
      };

      const viewport = window.visualViewport;
      viewport?.addEventListener("resize", onResize);
      viewport?.addEventListener("scroll", onResize);

      // Executa uma vez inicial
      onResize();

      return () => {
          viewport?.removeEventListener("resize", onResize);
          viewport?.removeEventListener("scroll", onResize);
      };
  }, []);

  // useEffect(() => {
  //     const handleKeyboardHeightChange = () => {
  //         const nativeNavigationHeight = getNativeNavigationHeight() ?? 0;

  //         setBottomPadding(nativeNavigationHeight);
  //     };

  //     window.addEventListener("keyboardHeightChange", handleKeyboardHeightChange);

  //     return () => {
  //         window.removeEventListener("keyboardHeightChange", handleKeyboardHeightChange);
  //     };
  // }, []);

  
  // function ajustaNewApp() {
  //     if((isNewApp() && isNewAppAndroid()) || isIOSWebView()){
  //         const nativeNavigationHeight = getNativeNavigationHeight();

  //         if(nativeNavigationHeight && nativeNavigationHeight > 0){
  //             setBottomPadding(nativeNavigationHeight);
  //         }

  //         window.addEventListener("navigationBarHeightChange", ajustaNewApp);
  //         return () => window.removeEventListener("navigationBarHeightChange", ajustaNewApp);
  //     }
  // }
  // useEffect(() => {
  //     ajustaNewApp()
  // }, []);

   // impede de voltar tela ao clicar em voltar com modal aberto
    useEffect(() => {
        if(userIndex !== null) window.history.pushState({ isModal: true }, "");
        else window.history.pushState({ isModal: false }, "");
    }, [userIndex]);
    useEffect(() => {
        const handlePopState = (event: any) => {
            if (userIndex !== null) {
                onClose()
            }
        };

        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, [open]);

  const handlePressStart = (type: "mouse" | "touch") => {
    if (type == "mouse" && window.innerWidth <= 850) return;
    isHoldRef.current = false;

    holdTimeoutRef.current = setTimeout(() => {
      isHoldRef.current = true;
      pauseStory();
    }, 200); // tempo mínimo pra virar HOLD
  };

  const handlePressEnd = (type: "mouse" | "touch", action?: () => void) => {
    if (type == "mouse" && window.innerWidth <= 850) return;
    if (holdTimeoutRef.current) {
      clearTimeout(holdTimeoutRef.current);
      holdTimeoutRef.current = null;
    }

    if (isHoldRef.current) {
      resumeStory();
      isHoldRef.current = false;
      return;
    }

    // 🔒 proteção extra
    if (isHolding) return;

    action?.();
  };

  const onCloseDelete = () => {
    setPassword("");
    setShowConfirmation(true);
    setShowConfirmation(false);
  };

  const pauseAndResetStory = () => {
    // Para timer (imagem)
    clearTimer();
    setProgress(0);

    // Para vídeo
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };

  const pauseStory = () => {
    setIsHolding(true);
    clearTimer();

    // pausa vídeo
    if (currentStory.media_type === "video") {
      videoRef.current?.pause();
    }

    // salva progresso atual
    holdProgressRef.current = progress;
  };

  const resumeStory = () => {
    setIsHolding(false);

    // imagem → continua timer de onde parou
    if (currentStory.media_type === "image") {
      clearTimer();

      const remaining = 100 - holdProgressRef.current;
      const remainingTime = (remaining / 100) * STORY_TIME;
      const step = remaining / (remainingTime / 100);

      intervalRef.current = setInterval(() => {
        setProgress((p) => {
          if (p >= 100) {
            clearTimer();
            nextStory();
            return 100;
          }
          return p + step;
        });
      }, 100);
    }

    // vídeo → continua
    if (currentStory.media_type === "video") {
      videoRef.current?.play();
    }
  };

  const clearTimer = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const startProgress = () => {
    clearTimer();
    setProgress(0);

    const step = 100 / (STORY_TIME / 100);

    intervalRef.current = setInterval(() => {
      setProgress((p) => {
        if (p >= 100) {
          clearTimer();
          nextStory();
          return 100;
        }
        return p + step;
      });
    }, 100);
  };

  useEffect(() => {
    if (currentStory.media_type === "image") {
      startProgress();
    }
    return clearTimer;
  }, [storyIndex, userIndex]);

  const nextUser = () => {
    if (userIndex < usersStories.length - 1) {
      const nextIndex = userIndex + 1;
      if (onLoadMore && nextIndex >= usersStories.length - 2) {
        onLoadMore();
      }
      setUserIndex(nextIndex);
      setStoryIndex(0);
    } else {
      onLoadMore?.();
      onClose();
    }
  };

  const nextStory = () => {
    clearTimer(); // 🔥 ISSO RESOLVE 80% DOS CASOS

    if (storyIndex < currentUser.stories.length - 1) {
      setStoryIndex((prev) => prev + 1);
    } else {
      nextUser();
    }
  };

  const prevStory = () => {
    clearTimer();

    if (storyIndex > 0) {
      setStoryIndex((prev) => prev - 1);
    } else if (userIndex > 0) {
      const prevUser = usersStories[userIndex - 1];
      setUserIndex(userIndex - 1);
      setStoryIndex(prevUser.stories.length - 1);
    }
  };

  useEffect(() => {
    if (!showConfirmation && currentStory.media_type === "image") {
      startProgress();
    }

    if (!showConfirmation && currentStory.media_type === "video") {
      videoRef.current?.play();
    }
  }, [showConfirmation]);

  const confirmDelete = async (password: string) => {
    const url = PACOCA_API_URL + `/stories/delete/${currentStory?.id}`;
    setErrorModalPassword("");
    setIsLoading(true);

    try {
      if (user?.id !== currentStory?.id_user && !password) {
        setErrorModalPassword("Informe sua senha");
        setIsLoading(false);
        return;
      }
      if (user?.id !== currentStory?.id_user && !reasonDeletePost) {
        setErrorModalPassword("Informe o motivo");
        setIsLoading(false);
        return;
      }
      if (user?.id !== currentStory?.id_user && (reasonDeletePost?.length <= 2 || reasonDeletePost?.toLowerCase() == "regras" || reasonDeletePost?.toLowerCase() == "regra")) {
        setErrorModalPassword("Explique melhor o motivo");
        setIsLoading(false);
        return;
      }

      await axios.post(
        url,
        { password, id_post: currentStory?.id, reason: reasonDeletePost },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      onStoryDeleted(currentStory.id, currentStory.id_user);
      onClose();
      setShowConfirmation(false);
      setMessage("Story excluido", "success");
      setPassword("");
    } catch (err: any) {
      const messageError = errorMessage(err);
      if(messageError.includes("Verifique sua conexão de internet")){
        onClose();
        setShowConfirmation(false);
        setMessage("Story excluido", "success");
        setPassword("");
        return;
      }
      setErrorModalPassword(messageError);
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <div
      className="user-select-none position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center"
      style={{ zIndex: 1055, touchAction: "none", }}
    >

      <div style={{ position: "absolute", inset: 0, overflow: "hidden", background: "#000" }}>
          {/* VÍDEO DE FUNDO BORRADO */}
          {currentStory.media_type == "image" ? (
            <div className="bg-image-story" style={{ backgroundImage: `url("${getImagePathBucketPacoca(currentStory.media_url)}")` }}/>
          ) : (
              <video
                src={getImagePathBucketPacoca(currentStory.media_url)}
                loop
                muted
                playsInline
                style={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    filter: "blur(30px)",
                    transform: "scale(1.2)"
                }}
            />
          )}

          <div
              style={{
                  position: "absolute",
                  inset: 0,
                  zIndex: 0,
                  background: "rgba(0,0,0,0.35)"
              }}
          />
      </div>

      <div className="view-story">
        {/* PROGRESSO */}
        <div className="position-absolute top-0 start-0 w-100 px-2 pt-2">
          <div className="d-flex gap-1">
            {currentUser.stories.map((_, i) => (
              <div
                key={i}
                className="flex-grow-1 bg-secondary rounded"
                style={{ height: 3 }}
              >
                <div
                  className="bg-white h-100 rounded"
                  style={{
                    width:
                      i < storyIndex
                        ? "100%"
                        : i === storyIndex
                        ? `${progress}%`
                        : "0%",
                    transition: "width 100ms linear",
                  }}
                />
              </div>
            ))}
          </div>
        </div>

        {/* <div
          className="name-story position-absolute start-0 w-100 d-flex align-items-center px-3"
          style={{ marginTop: 20, zIndex: 10 }}
        >
          <img
            src={getImagePathBucketPacoca(currentStory.user?.img_account, "/img/img-account.png")}
            alt={currentStory.user?.name}
            onClick={() => navigate(`/@${currentStory.user?.user_name}`)}
            className="rounded-circle me-2 cursor-pointer"
            style={{
              width: 40,
              height: 40,
              objectFit: "cover",
              border: "2px solid white",
            }}
          />

          <div className="text-white cursor-pointer" onClick={() => navigate(`/@${currentStory.user?.user_name}`)}>
            <strong style={{ fontSize: 14 }}>{currentStory.user?.name}</strong>
            <div style={{ fontSize: 12, opacity: 0.8 }}>
              {currentStory.user?.user_name && `@${currentStory.user.user_name}`}
            </div>
          </div>
        </div>

        <button
          className="btn-x-right btn-close svg-icons-color btn-dark cursor-pointer"
          onClick={onClose}
          style={{ top: 20, zIndex: 11 }}
        >
          ✕
        </button>
        {currentStory.media_type == "video" ? (
          <button
            className="btn-x-right btn-close svg-icons-color btn-dark cursor-pointer"
            style={{ top: 20, right: 40, zIndex: 11 }}
            onClick={() => setIsMuted((prev) => !prev)}
          >
            {isMuted ? "🔇" : "🔊"}
          </button>
        ) : null} */}

        {/* Barra superior */}
        <div
          className={`story-top-bar ${isHolding ? 'story-ui-hidden' : ''}`}
          style={{ marginTop: 20, zIndex: 10 }}
        >
          {/* Avatar + nome */}
          <div className="story-top-bar__user" onClick={() => navigate(`/@${currentStory.user?.user_name}`)}>
            <img
              src={getImagePathBucketPacoca(currentStory.user?.img_account, "/img/img-account.png")}
              alt={currentStory.user?.name}
              className="story-top-bar__avatar"
            />
            <div className="story-top-bar__info">
              <strong>{currentStory.user?.name}</strong>
              {currentStory.user?.user_name && (
                <span>@{currentStory.user.user_name}</span>
              )}
            </div>
          </div>

          {/* Ações à direita */}
          <div className="story-top-bar__actions">
            {currentStory.media_type === "video" && (
              <button className="story-action-btn" onClick={() => setIsMuted(p => !p)}>
                {isMuted ? "🔇" : "🔊"}
              </button>
            )}

            {currentStory.is_best_friends && (
              <button
                className="story-action-btn story-best-friends-star"
                aria-label="Story para melhores amigos"
                onClick={() => {
                  pauseStory();
                  setShowBestFriendsInfo(true);
                }}
              >
                <Star size={17} fill="#8b5a2b" color="#8b5a2b" />
              </button>
            )}

            <PermissionCheck permission="delete_post" id_owner={currentStory?.id_user}>
              {currentStory.user && user &&
                (user?.position < currentStory.user?.position ||
                  (!currentStory.user?.position && user?.position) ||
                  isSuper() ||
                  user.id == currentStory.id_user) && (
                <button
                  className="story-action-btn"
                  onClick={() => { pauseAndResetStory(); setShowConfirmation(true); }}
                >
                  <Trash2 size={16} />
                </button>
              )}
            </PermissionCheck>

            <button className="story-action-btn" onClick={onClose}>✕</button>
          </div>
        </div>

        {/* <PermissionCheck
          permission="delete_post"
          id_owner={currentStory?.id_user}
        >
          {currentStory.user &&
          user &&
          (user?.position < currentStory.user?.position ||
            (!currentStory.user?.position && user?.position) ||
            isSuper() ||
            user.id == currentStory.id_user) ? (
            <button
              className="btn-x-right btn-close svg-icons-color btn-dark"
              onClick={() => {
                pauseAndResetStory();
                setShowConfirmation(true);
              }}
              style={{
                top: 20,
                right: currentStory.media_type == "video" ? 80 : 45,
                zIndex: 11,
              }}
            >
              <Trash2 />
            </button>
          ) : null}
        </PermissionCheck> */}

        {/* CLICK AREAS */}
        {/* <div className="position-absolute start-0 top-0 h-100 w-50" onClick={prevStory} />
        <div className="position-absolute end-0 top-0 h-100 w-50" onClick={nextStory} /> */}
        {/* VOLTAR */}
        <div
          style={{ zIndex: 9 }}
          className="position-absolute start-0 top-0 h-100 w-50"
          onMouseDown={() => handlePressStart("mouse")}
          onMouseUp={() => handlePressEnd("mouse", prevStory)}
          onTouchStart={() => handlePressStart("touch")}
          onTouchEnd={() => handlePressEnd("touch", prevStory)}
        />

        {/* AVANÇAR */}
        <div
          className="position-absolute end-0 top-0 h-100 w-50"
          style={{ zIndex: 9 }}
          onMouseDown={() => handlePressStart("mouse")}
          onMouseUp={() => handlePressEnd("mouse", nextStory)}
          onTouchStart={() => handlePressStart("touch")}
          onTouchEnd={() => handlePressEnd("touch", nextStory)}
        />

        {/* MIDIA */}
        <div
          className="w-100 h-100 d-flex justify-content-center align-items-center"
          onMouseDown={pauseStory}
          onMouseUp={resumeStory}
          onMouseLeave={resumeStory}
          onTouchStart={pauseStory}
          onTouchEnd={resumeStory}
        >
          {currentStory.media_type === "image" ? (
            <img
              src={getImagePathBucketPacoca(currentStory.media_url)}
              className="img-fluid"
              style={{ maxHeight: "100vh" }}
            />
          ) : (
            <ReactPlayer
              url={getImagePathBucketPacoca(currentStory.media_url)}
              playing={!showConfirmation && !isHolding}
              muted={isMuted}
              volume={isMuted ? 0 : 1}
              playsinline
              width="100%"
              height="100%"
              style={{ objectFit: "cover" }}
              onPlay={clearTimer}
              onEnded={nextStory}
              config={{
                file: {
                  attributes: {
                    controlsList: "nodownload",
                    disablePictureInPicture: true,
                  },
                },
              }}
            />

            // <video
            //   src={getImagePathBucketPacoca(currentStory.media_url)}
            //   className="w-100"
            //   style={{ maxHeight: "100vh" }}
            //   autoPlay
            //   playsInline
            //   onEnded={nextStory}
            //   onPlay={clearTimer}
            // />
          )}
        </div>

        {/* BOLINHAS EMBAIXO */}
        <div className="position-absolute start-0 w-100 pb-3 d-flex justify-content-center gap-2" style={{ bottom: bottomPadding - window.innerWidth <=850 ?  15 : 5 }}>
          {currentUser.stories.map((_, i) => (
            <span
              key={i}
              className={`rounded-circle ${
                i === storyIndex ? "bg-white" : "bg-secondary"
              }`}
              style={{ width: 8, height: 8 }}
            />
          ))}
        </div>

        {showBestFriendsInfo && (
          <div
            className="story-best-friends-dialog-backdrop"
            role="presentation"
            onClick={() => {
              setShowBestFriendsInfo(false);
              resumeStory();
            }}
          >
            <section
              className="story-best-friends-dialog"
              role="dialog"
              aria-modal="true"
              aria-labelledby="story-best-friends-dialog-title"
              onClick={event => event.stopPropagation()}
            >
              <Star size={26} fill="#8b5a2b" color="#8b5a2b" />
              <h2 id="story-best-friends-dialog-title">Melhores amigos</h2>
              <p>Este story foi compartilhado apenas com os melhores amigos.</p>
              <button
                type="button"
                onClick={() => {
                  setShowBestFriendsInfo(false);
                  resumeStory();
                }}
              >
                Entendi
              </button>
            </section>
          </div>
        )}

        <ConfirmationModal
          show={showConfirmation}
          onClose={() => onCloseDelete()}
          onConfirm={() => confirmDelete(password)} // Passa a senha aqui
          title="Excluir Story"
          coverMobile={currentStory?.id_user != user?.id}
          text="Tem certeza que deseja excluir esse story?"
          requirePassword={currentStory?.id_user != user?.id}
          setPassword={setPassword} // Adicione a função setPassword aqui
          errorMessage={errorModal}
          isLoading={isLoading}
          extraContent={
            <>
              {currentStory?.id_user != user?.id ? (
                <>
                  <textarea
                    placeholder="Motivo"
                    value={reasonDeletePost}
                    onChange={(e) => setReasonDeletePost(e.target.value)}
                    className={`mt-3 form-control`}
                    name="text"
                    style={{ color: isLimitExceeded ? "red" : "inherit" }}
                    cols={30}
                    rows={10}
                  />

                  <div className="user-select-none limite-denuncia">
                    {reasonDeletePost?.length}/{LIMIT_TEXT_REPORT}
                  </div>
                </>
              ) : null}
            </>
          }
        />
    </div>

    <StoryInteractions
      storyId={currentStory.id}
      reactions={currentStory.reactions ?? []}
      onPause={pauseStory}
      isHolding={isHolding}
      onResume={resumeStory}
      initiallyOpen={initiallyShowComments}
    />
    </div>
  );
};

export default StoryViewer;
